export default __webpack_public_path__ + "static/media/MP0057.76ffa6a3.jpg";